module.exports = __webpack_public_path__ + "static/media/phone.0eae9d10.PNG";